import React, { createContext, useContext, useState, useEffect } from "react";

import { SurveyContext } from "./survey";

import * as QuestionsVisibility from "../utils/survey/questions-visibility";
import * as Storage from "../utils/storage";

export const SurveyQuestionsVisibilityContext = createContext();

const SurveyQuestionsVisibilityProvider = ({ children }) => {
  const { questionnaire, answers } = useContext(SurveyContext);

  const [questionsVisibility, setQuestionsVisibility] = useState(
    QuestionsVisibility.loadQuestionsVisibility(questionnaire, answers)
  );

  const updateQuestionsVisibility = (dimensionIndex, questionIndex) => {
    setQuestionsVisibility({
      ...QuestionsVisibility.updateQuestionsVisibility(
        questionnaire,
        questionsVisibility,
        dimensionIndex,
        questionIndex,
        answers
      ),
    });
  };

  useEffect(() => {
    Storage.setItem(["survey", "questionsVisibility"], questionsVisibility);
  }, [questionsVisibility]);

  return (
    <SurveyQuestionsVisibilityContext.Provider
      value={{ questionsVisibility, updateQuestionsVisibility }}
    >
      {children}
    </SurveyQuestionsVisibilityContext.Provider>
  );
};

export default SurveyQuestionsVisibilityProvider;
